<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{ $route.meta.title }}</h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>审单考核管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="true">
      <template slot="header">搜索</template>
      <el-form :model="search"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()"
               ref="searchForm">
        <div class="re-el-form__flex">
          <el-form-item label="项目" prop="projectid">
            <remote-select
              v-model="search.projectid"
              placeholder="请输入项目名称/编号搜索"
              clearable
              class="width-max"
              id-key="number"
              label-key="name"
              value-key="id"
              :query-request="getProjectTable"
              :query-params="{}"
              :find-request="getProjectDetail">
            </remote-select>
          </el-form-item>
        </div>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit"
                     size="mini">搜索
          </el-button>
          <el-button @click="resetForm('searchForm')"
                     size="mini">重置
          </el-button>
          <el-button @click="onExportSearch"
                     size="mini">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button type="primary"
                   size="mini"
                   icon="el-icon-plus"
                   @click="handleAdd">新增目标配置
        </el-button>
      </div>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">

        <el-table-column prop="id"
                         label="ID"
                         width="80">
        </el-table-column>
        <el-table-column prop="projectid"
                         label="项目ID"
                         width="100"
                         align="center">
        </el-table-column>
        <el-table-column prop="projectname"
                         label="项目名称"
                         min-width="150">
        </el-table-column>
        <el-table-column prop="project_leader"
                         label="项目组长"
                         min-width="120"
                         align="center">
        </el-table-column>
        <el-table-column prop="intern_count"
                         label="审核参与人数"
                         min-width="120"
                         align="center">
        </el-table-column>
        <el-table-column prop="project_period"
                         label="项目目标值周期"
                         min-width="200"
                         align="center">
          <template slot-scope="scope">
            {{ formatPeriod(scope.row.start_date, scope.row.end_date) }}
          </template>
        </el-table-column>
        <el-table-column prop="plan_order_count"
                         label="项目总目标（次）"
                         width="120"
                         align="center">
        </el-table-column>
        <el-table-column prop="finished_audit_times"
                         label="项目累计完成（次）"
                         width="120"
                         align="center">
        </el-table-column>
        <el-table-column prop="creator"
                         label="创建人"
                         width="120"
                         align="center">
        </el-table-column>
        <el-table-column prop="created_at"
                         label="创建时间"
                         width="180"
                         align="center">
        </el-table-column>
        <el-table-column label="操作"
                         width="120"
                         fixed="right">
          <template slot-scope="scope">
            <el-button type="text"
                       size="small"
                       @click="handleTargetSetting(scope.row)">目标设置
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <!-- 创建/编辑弹窗 -->
    <target-setting-form-dialog ref="formDialog"
                                @submitted="onFormSubmitted">
    </target-setting-form-dialog>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import TargetSettingFormDialog from '../components/TargetSettingFormDialog.vue'

export default {
  mixins: [table],
  components: {
    TargetSettingFormDialog,
  },
  data () {
    return {
      search: {
        projectid: null,
      },
      searchFieldType: {
        projectid: Number,
      },
      table: [],
      exportHeader: [
        {
          key: 'id',
          text: 'ID',
        },
        {
          key: 'projectid',
          text: '项目ID',
        },
        {
          key: 'projectname',
          text: '项目名称',
        },
        {
          key: 'project_leader',
          text: '项目负责人',
        },
        {
          key: 'plan_order_count',
          text: '计划订单数',
        },
        {
          key: 'finished_audit_times',
          text: '已完成审单次数',
        },
        {
          key: 'project_period',
          text: '项目目标值周期',
        },
        {
          key: 'creator',
          text: '创建人',
        },
        {
          key: 'created_at',
          text: '创建时间',
        },
      ],
    }
  },
  methods: {
    ...request.map([
      'getProjectDetail',
      'getBaiscProjectTable',
    ]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getTargetSettingTable', params)
    },
    /**
     * 获取项目列表（用于搜索）
     * 直接使用 request.map 生成的方法可能有问题，手动包装确保参数正确传递
     */
    getProjectTable (params) {
      return request('getBaiscProjectTable', params)
    },
    // 获取项目详情（用于 RemoteSelect）
    getProjectDetail (params) {
      return request('getProjectDetail', params)
    },
    /**
     * 导出搜索
     */
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
        getResponseData: (data) => {
          if (data && data.data) {
            data.data = this.handleExportData(data.data)
          }
          return data
        }
      })
    },
    /**
     * 处理导出数据
     */
    handleExportData (data) {
      if (!data || !Array.isArray(data)) {
        return []
      }
      return data.map(row => {
        return {
          ...row,
          project_period: this.formatPeriod(row.start_date, row.end_date)
        }
      })
    },
    /**
     * 重置表单
     */
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.onSearch()
    },
    /**
     * 格式化项目目标值周期
     */
    formatPeriod (start, end) {
      if (!start || !end) {
        return '-'
      }
      const formatDate = date => {
        if (!date) return ''
        // 后端返回的是字符串格式的日期 "2026-01-27 00:00:00"
        const d = new Date(date)
        if (isNaN(d.getTime())) {
          return date
        }
        return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}`
      }
      return `${formatDate(start)} ~ ${formatDate(end)}`
    },
    /**
     * 新增目标配置
     */
    handleAdd () {
      // 如果搜索栏已选择项目，则预填充到弹窗
      const projectId = this.search.projectid || null
      this.$refs.formDialog.show(projectId)
    },
    /**
     * 表单提交成功后的回调
     */
    onFormSubmitted () {
      this.onRefresh()
    },
    /**
     * 目标设置
     */
    handleTargetSetting (row) {
      this.$router.push({
        name: '目标设置',
        params: {
          projectId: row.projectid,
        },
        query: {
          projectId: row.projectid,
          audit_project_range_id: row.id,
        },
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>




// WEBPACK FOOTER //
// src/views/order-review-target-management/pages/TargetProjectSettingTable.vue